<div class="c-page-saa">
    <div class="container u-pb30">
        <div class="row mobile--orange u-pt40">
            <div class="col-md-12">
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item"><a [routerLink]="['/']">{{'IncomingDetailsPortal.home'| translate}}&nbsp;</a></li>
                        <li class="breadcrumb-item active" aria-current="page">- <a [routerLink]="['/incoming-access-requests']"> {{'IncomingDetailsPortal.level2'| translate}}</a></li>
                        <li class="breadcrumb-item active" aria-current="page">&nbsp;- <span> {{'IncomingDetailsPortal.location'| translate}}</span></li>
                    </ol>
                </nav>
                <h2 class="o-title" *ngIf="type.Id===1"> {{'IncomingDetailsPortal.titleEmployee' | translate}} - Nº {{id}}</h2>
                <h2 class="o-title" *ngIf="type.Id===2">{{'IncomingDetailsPortal.titleContractor' | translate}} - Nº {{id}}</h2>
                <h2 class="o-title" *ngIf="type.Id===3">{{'IncomingDetailsPortal.titleVisitors' | translate}} - Nº {{id}}</h2>
                <h2 class="o-title" *ngIf="type.Id===4">{{'IncomingDetailsPortal.titleException' | translate}} - Nº {{id}}</h2>
            </div>
        </div>
        <div class="row u-pt30">
            <div class="col-md-12">
                <div class="c-card c-card--small">
                    <div class="row">
                        <div class="col-md-4">
                            <p> <strong>{{'IncomingDetailsPortal.labelAccessRequestor' | translate}}:</strong> {{SeeItems.requestorName}}</p>
                        </div>
                        <div class="col-md-4">
                            <p> <strong>{{'IncomingDetailsPortal.labelJobTitle' | translate}}:</strong> {{SeeItems.requestorTitle | titlecase}}</p>
                        </div>
                        <div class="col-md-4">
                            <p> <strong>{{'IncomingDetailsPortal.labelEmail' | translate}}:  </strong> {{SeeItems.requestorEmail}} </p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-12 u-pt30">
                <h2 class="o-title o-title--medium o-title--orange">{{'IncomingDetailsPortal.detailTitle' | translate}} </h2>
                <h4 class="o-title o-title--medium"><span>{{'IncomingDetailsPortal.labelStatus' | translate}}: </span>
                    <strong class="gray">
                        <strong class="gray" *ngIf="status.Id===1">{{'IncomingDetailsPortal.statusOnProcess' | translate}}</strong>
                    <strong class="gray" *ngIf="status.Id===3">{{'IncomingDetailsPortal.statusReject' | translate}}</strong>
                    <strong class="gray" *ngIf="status.Id===11">{{'IncomingDetailsPortal.statusTerminated' | translate}}</strong>
                    <strong class="gray" *ngIf="status.Id===2">{{'IncomingDetailsPortal.statusApproved' | translate}}</strong>

                    <strong class="gray" *ngIf="status.Id===5">{{'IncomingDetailsPortal.statusPendingSarApp' | translate}}</strong>
                    <strong class="gray" *ngIf="status.Id===9">{{'IncomingDetailsPortal.statusRejectedSarApp' | translate}} </strong>
                    <strong class="gray" *ngIf="status.Id===7">{{'IncomingDetailsPortal.statusApprovedSarApp' | translate}}</strong>

                    <strong class="gray" *ngIf="status.Id===6">{{'IncomingDetailsPortal.statusPendingFacility' | translate}}</strong>
                    <strong class="gray" *ngIf="status.Id===10">{{'IncomingDetailsPortal.statusRejectedFacility' | translate}}</strong>
                    <strong class="gray" *ngIf="status.Id===8">{{'IncomingDetailsPortal.statusApprovedFacility' | translate}}</strong>

                    <strong class="gray" *ngIf="status.Id===4">{{'IncomingDetailsPortal.statusDelegate' | translate}}</strong>
                    </strong>
                    &nbsp;
                    <i *ngIf="status.Id==1  ||  status.Id==5  ||  status.Id==6" class="icon icon-more"> </i>
                    <i *ngIf="status.Id==3  ||  status.Id==9  ||  status.Id==10" class="icon icon-close"> </i>
                    <i *ngIf="status.Id==11" class="icon icon-close"> </i>
                    <i *ngIf="status.Id==2  ||  status.Id==7  ||  status.Id==8" class="icon icon-check"> </i>
                    <i *ngIf="status.Id==4" class="icon icon-arrow" style=" transform: rotateY(180deg);">  </i></h4>

            </div>
            <div class="col-md-12">
                <div class="c-card c-card--detail">
                    <div class="row">
                        <div class="col-md-12" style="padding-left: 0px;padding-top: 7px;">
                            <div class="col-md-3"><strong>{{'IncomingDetailsPortal.labelAccessRequestor' | translate}}:</strong>
                                <p>{{SeeItems.requestorName}}</p>
                            </div>
                            <div class="col-md-3"><strong>{{'IncomingDetailsPortal.labelType' | translate}}:</strong>

                                <p *ngIf="type.Id == 1"> {{'IncomingDetailsPortal.employee' | translate }} </p>
                                <p *ngIf="type.Id == 2"> {{'IncomingDetailsPortal.contractor' | translate }} </p>
                                <p *ngIf="type.Id == 3"> {{'IncomingDetailsPortal.visitors' | translate }} </p>
                                <p *ngIf="type.Id == 4"> {{'IncomingDetailsPortal.exception' | translate }} </p>
                            </div>
                        </div>

                        <div class="col-md-12" style="padding-left: 0px;padding-top: 7px;">
                            <div class="col-md-3"><strong>{{'IncomingDetailsPortal.labelSite' | translate}}:</strong>
                                <p>{{SeeItems.siteName}}</p>
                            </div>
                            <div class="col-md-3"><strong>{{'IncomingDetailsPortal.labelZone' | translate}}:</strong>
                                <p>{{SeeItems.zoneName}}</p>
                            </div>
                            <div class="col-md-3" *ngIf="SeeItems.subZoneName">
                                <strong class="js-txt19">{{'IncomingDetailsPortal.labelSubZone' | translate}}:</strong>
                                <p>{{SeeItems.subZoneName}}</p>
                            </div>
                        </div>
                        <div class="col-md-12" style="padding-left: 0px;padding-top: 7px;">
                            <div class="col-md-3"><strong>{{'IncomingDetailsPortal.labelFrom' | translate}}:</strong>
                                <p>{{SeeItems.periodFrom | date: 'dd/MM/yyyy'}}</p>
                            </div>
                            <div class="col-md-3"><strong>{{'IncomingDetailsPortal.labelTo' | translate}}:</strong>
                                <p>{{SeeItems.periodTo | date: 'dd/MM/yyyy'}}</p>
                            </div>

                            <!-- Msg validator date mora than 30days-->
                            <!-- <div class="col-md-6" *ngIf="dateValn" style="margin-bottom: 15px; background-color: #F2F0E9" align="center">
                                <span><h5 style="padding: 15px;"><mat-error style=" white-space: normal; ">
                                <i class="icon icon-warning"></i> caution: request contains 30 or more days</mat-error></h5></span>
                            </div> -->
                        </div>
                        <div class="col-md-6" *ngIf="dateValn" style="margin-bottom: 15px; background-color: #F2F0E9" align="center">
                            <span><h5 style="padding: 15px;"><mat-error style=" white-space: normal; ">
                            <i class="icon icon-warning"></i> {{'IncomingDetailsPortal.daysValidation' | translate}}</mat-error></h5></span>
                        </div>
                        <div class="col-md-12" *ngIf="OneDayValidation==true && type.Id===3 && SeeItems.siteCC=='ESC' && SeeItems.zoneCodeCC=='EDI' || OneDayValidation==true && type.Id===3 && SeeItems.siteCC=='SCL' && SeeItems.zoneCodeCC=='CEP'" style="padding-left: 0px;padding-top: 7px;">
                            <span><h5 style="padding: 15px;"><mat-error style=" white-space: normal; ">
                              <i class="icon icon-warning"></i> {{'IncomingDetailsPortal.labelOneDayWarn' | translate}} </mat-error></h5></span>
                        </div>
                        <div class="col-md-12" style="padding-left: 0px;padding-top: 7px;">
                            <div class="col-md-3"><strong>{{'IncomingDetailsPortal.labelAccessApprover' | translate}}:</strong>
                                <p>{{SeeItems.accessApproverName}}</p>
                            </div>
                            <div class="col-md-3" *ngIf="SeeItems.facilityEnabled"><strong>{{'IncomingDetailsPortal.labelFacilityApprover' | translate}}:</strong>
                                <p>{{SeeItems.facilityApproverName}}</p>
                            </div>
                            <div class="col-md-3" *ngIf="SeeItems.facilityEnabled"><strong>{{'IncomingDetailsPortal.labelFirstPriority' | translate}}:</strong>
                                <p *ngIf="SeeItems.facilityPriority==='True'">{{'IncomingDetailsPortal.facility' | translate}}</p>
                                <p *ngIf="SeeItems.facilityPriority==='False'">{{'IncomingDetailsPortal.sarApprover' | translate}}</p>
                            </div>
                        </div>
                        <div class="col-md-12" style="padding-left: 0px;padding-top: 7px;" *ngIf="SeeItems.facilityModifiedBy!='' || SeeItems.accessModifiedBy!= ''">
                            <div class="col-md-3" *ngIf="SeeItems.accessModifiedBy!=''"><strong>{{'IncomingDetailsPortal.labelAccessApproverModifyBy' | translate}}:</strong>
                                <p>{{SeeItems.accessModifiedBy}}</p>
                            </div>
                            <div class="col-md-3" *ngIf="SeeItems.facilityEnabled && SeeItems.facilityModifiedBy!= ''"><strong>{{'IncomingDetailsPortal.labelFacilityApproverModifyBy' | translate}}:</strong>
                                <p>{{SeeItems.facilityModifiedBy}}</p>
                            </div>

                        </div>
                        <div class="col-md-12" style="padding-top: 7px;"><strong>{{'IncomingDetailsPortal.purposeVisit' | translate}}:</strong>
                            <p>{{SeeItems.purpose}}</p>
                        </div>
                        <div class="col-md-12" style="padding-top: 7px;"><strong>{{'IncomingDetailsPortal.commentary' | translate}}:</strong>
                            <p>{{SeeItems.commentary}}</p>
                        </div>
                    </div>
                </div>
                <hr class="big">
            </div>

            <div class="col-md-12">
                <h2 class="o-title o-title--medium o-title--orange" *ngIf="type.Id===1 || type.Id===2 || type.Id===4">{{'IncomingDetailsPortal.employeesDetails' | translate}}</h2>
                <h2 class="o-title o-title--medium o-title--orange" *ngIf="type.Id===3">{{'IncomingDetailsPortal.visitorsDetails' | translate}}</h2>
                <p class="o-text" *ngIf="type.Id===1 || type.Id===2 || type.Id===4">{{'IncomingDetailsPortal.subTitleEmployeesDetails' | translate}}</p>
                <p class="o-text" *ngIf="type.Id===3">{{'IncomingDetailsPortal.subTitleVisitorsDetails' | translate}}</p>
            </div>

            <div class="col-md-12" style="margin-bottom: 20px;" *ngIf="hasRestrictedPerson">
                <div class="c-card c-card--small">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="box-flex">
                                <img src="../assets/img/alerta.png" alt="img" class="box-flex__img">
                                <p>{{'IncomingDetailsPortal.messageRestrictedPerson' | translate}}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-md-12">
                <table class="table table--clean">
                    <thead>
                        <tr>
                            <th>{{'IncomingDetailsPortal.colNumber' | translate}}</th>
                            <th>{{'IncomingDetailsPortal.colRUT' | translate}}</th>
                            <th>{{'IncomingDetailsPortal.colPassport' | translate}}</th>
                            <th>{{'IncomingDetailsPortal.colFullName' | translate}}</th>
                            <th>{{'IncomingDetailsPortal.colNationality' | translate}}</th>
                            <th>{{'IncomingDetailsPortal.colEmail' | translate}}</th>
                            <th *ngIf="type.Name==='Visitors'">{{'IncomingDetailsPortal.colFormStatus' | translate}}</th>
                            <th *ngIf="type.Name==='Visitors' && qualificationDummy && lang==='en'"> {{ qualificationDummy.nameEn}}</th>
                            <th *ngIf="type.Name==='Visitors' && qualificationDummy && lang==='es'"> {{ qualificationDummy.nameEs}}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let p of people; index as i">
                            <td class="table__number" [ngClass]="{'restricted__color': p.isRestrictedPerson }">
                                <p class="green" *ngIf="(p.accessCount < 3) || type.Id!=3">
                                    {{i+1}}
                                </p>
                                <p style="color: coral;font-weight: 500" *ngIf="(p.accessCount >= 3)">
                                    {{i+1}}
                                </p>
                            </td>
                            <td style="padding-left: 5px;padding-right: 5px;text-align: center;white-space: nowrap" *ngIf="type.Id===3" [ngClass]="{'restricted__color': p.isRestrictedPerson}">
                                <p class="green" *ngIf="(p.nationalId && (p.accessCount < 3))">
                                    {{p.nationalId}}
                                </p>

                                <p style="color: coral;font-weight: 500" *ngIf="p.nationalId && (p.accessCount >= 3)">
                                    {{p.nationalId}}
                                    <span class="ptooltip title--tooltip" matTooltipPosition="right" matTooltip="{{'IncomingDetailsPortal.tooltip'| translate}}: {{p.accessCount}}">         
                                        !
                                    </span>
                                </p>
                                <p *ngIf="!p.nationalId">
                                    -
                                </p>

                            </td>
                            <td *ngIf="type.Id!=3" [ngClass]="{'restricted__color': p.isRestrictedPerson}">
                                <p class="green" *ngIf="p.nationalId">
                                    {{p.nationalId}}
                                </p>
                                <p *ngIf="!p.nationalId">
                                    -
                                </p>
                            </td>
                            <td style="padding-left: 5px;padding-right: 5px;text-align: center;white-space: nowrap" *ngIf="type.Id===3" [ngClass]="{'restricted__color': p.isRestrictedPerson}">
                                <p class="green" *ngIf="(p.passportNumber && (p.accessCount < 3))">
                                    {{p.passportNumber}}
                                </p>
                                <p style="color: coral;font-weight: 500" *ngIf="p.passportNumber  && (p.accessCount >= 3)">
                                    {{p.passportNumber}}
                                    <span class="ptooltip title--tooltip" matTooltipPosition="right" matTooltip="{{'IncomingDetailsPortal.tooltip'| translate}}: {{p.accessCount}}">         
                                        !
                                    </span>
                                </p>
                                <p class="green" *ngIf="!p.passportNumber">
                                    -
                                </p>
                            </td>
                            <td *ngIf="type.Id!=3" [ngClass]="{'restricted__color': p.isRestrictedPerson}">
                                <p class="green" *ngIf="p.passportNumber">
                                    {{p.passportNumber}}
                                </p>
                                <p class="green" *ngIf="!p.passportNumber">
                                    -
                                </p>
                            </td>
                            <td [ngClass]="{'restricted__color': p.isRestrictedPerson}">
                                <p>{{p.fullName}}</p>
                            </td>
                            <td [ngClass]="{'restricted__color': p.isRestrictedPerson}">

                                <p>{{p.nationality}}</p>
                            </td>
                            <td [ngClass]="{'restricted__color': p.isRestrictedPerson}" style="  max-width: 200px;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            white-space: nowrap;" title="{{p.email}}">
                                {{p.email}}
                            </td>
                            <td [ngClass]="{'restricted__color': p.isRestrictedPerson}" style="text-align: center;" *ngIf="type.Name==='Visitors'">

                                <i class="icon icon-more" *ngIf="p.formStatus===false" title="Pending"> </i>
                                <i class="icon icon-check" *ngIf="p.formStatus===true" title="Approved"> </i>
                            </td>
                            <td [ngClass]="{'restricted__color': p.isRestrictedPerson}" style="text-align: center;" *ngIf="type.Name==='Visitors' && qualificationDummy">

                                <i class="icon icon-more" *ngIf="p.qualificationStatus===1 || p.qualificationStatus===0" title="Pending"> </i>
                                <i class="icon icon-check" *ngIf="p.qualificationStatus===2" title="Approved"> </i>
                                <i class="icon icon-close" *ngIf="p.qualificationStatus===3" title="Reject"> </i>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="row">

            <div class="col-md-12 u-pt80">
                <form class="o-form" [formGroup]="formAccessContractor">
                    <div class="o-form__checkbox u-mb20" *ngIf="(status.Name==='Pending' ||  status.Name=='Pending by SAR Approver'||  status.Name=='Pending by Facility') && SeeItems.approveEnabled===true ">
                        <input type="checkbox" value="value" formControlName="Confirm" name="Confirm" required><span></span>
                        <a class="open_modal js-txt34" (click)="openDialog()" data="terms" style="cursor:pointer">{{'IncomingDetailsPortal.boxConfirmTems' | translate}}</a>
                    </div>
                    <div align="center" *ngIf="formAccessContractor.controls['Confirm'].hasError('required') && submited" style="width:100%; background-color: #F2F0E9" class="col-md-12 col-xs-12 col-md-offset-0 col-xs-offset-2">
                        <h5 style="padding: 15px;"><i class="icon icon-close"></i>
                            <mat-error style=" white-space: normal;"> {{ 'IncomingDetailsPortal.confirm' | translate}}</mat-error>
                        </h5>
                    </div>
                </form>
            </div>
            <div class="col-md-12 u-pt50" *ngIf="status.Name==='Pending' || status.Name==='Delegate' ||  status.Name=='Pending by SAR Approver'||  status.Name=='Pending by Facility'">
                <button class="btn btn btn--primary" [routerLink]="['/incoming-access-requests']"> {{ 'IncomingDetailsPortal.btnBack' | translate}}</button >
                <button class="btn btn btn--primary" (click)="openDialogReject()"  *ngIf="SeeItems.approveEnabled===true">{{ 'IncomingDetailsPortal.btnReject' | translate}}</button>
                <button class="btn btn--primary " (click)="openDialogAccept()" *ngIf="approvedAccess && SeeItems.approveEnabled===true">{{ 'IncomingDetailsPortal.btnApprove' | translate}}</button>
            </div>

            <div class="col-md-12 u-pt50" *ngIf="status.Name!='Pending by Facility' && status.Name!='Pending by SAR Approver' && status.Name!='Pending' && status.Name!='Delegate' ">
                <button class="btn btn btn--primary" [routerLink]="['/incoming-access-requests']">{{ 'IncomingDetailsPortal.btnBack' | translate}}</button >
            </div>
    
      </div>
      <div *ngIf="!approvedAccess && status.Id!=3" style=" padding-top: 25px;">
      <div  style="width:100%; background-color: #F2F0E9;" align="center;" >
        <span><h5 style="padding: 15px;"><mat-error style=" white-space: normal; "><i class="icon icon-close"></i>{{'IncomingDetailsPortal.errorForm' | translate}}</mat-error></h5></span>
    </div>
  </div>
      <div class="row u-pt30" *ngIf="(status.Name==='Pending' || status.Name==='Delegate') && SeeItems.facilityEnabled===false"> 
        <div class="col-md-12">
          <div class="c-accordeon"> 
            <div class="c-accordeon__subtitle"  >
                <mat-accordion class="c-accordeon">
                    <div class="c-accordeon" >
                        <mat-expansion-panel  style="background-color:#F2F0E9">
                            <mat-expansion-panel-header>
                                <mat-panel-title>
                                    <h5>
                                        {{'IncomingDetailsPortal.delegateRequest' | translate}}
                                      </h5>
                                </mat-panel-title>
                            </mat-expansion-panel-header>
                            <div class="row" >
                              <form class="o-form" [formGroup]="formBle" >
                              
                                <div class="col-md-6">
                                  <div class="form-group ">
                                    <label class="o-title o-title--label ">{{'IncomingDetailsPortal.selectAccApprover' | translate}}: </label>
       
                                    

<!-- 

                                    <select class="o-form__select"  formControlName="approverDelegate">
                                      <option [value]="''" disabled >{{ 'IncomingDetailsPortal.selOption' | translate}}</option>
                                      <option [value]=item.mdmid *ngFor="let item of Approvers" > {{item.name}}</option>
                                    </select>
    
<hr>
 -->


                                    <div class="content-filter__group" >
                                        
                                            <input  type="text" class="o-form__select"  matInput [formControl]="toFormControl(formBle.controls['approverDelegate'])"  [matAutocomplete]="auto2"
                                            required >
                                        
                                        
                                        <mat-autocomplete #auto2="matAutocomplete" [displayWith]="displayFn">
                                            <mat-option *ngFor="let option of filteredOptions | async" [value]="option">
                                            <span mat-raised-button 
                                            aria-label="Button that displays a tooltip in various positions">
                                            {{option.name}}
                                            </span> <br>
                                            <small style="color: #E65400">{{option.email}}</small>
                                            </mat-option>
                                        </mat-autocomplete>
                                    </div>




                                  </div>
                                  <div class="u-pt0"> 
                                    <button class="btn btn--primary " (click)= "delegate()"
                                    [attr.disabled]="formBle.controls['approverDelegate'].hasError('required') ? true : null"
                                    bind-style.cursor="formBle.controls['approverDelegate'].hasError('required') ? 'no-drop' : ''"  
                                    >{{'IncomingDetailsPortal.delegate' | translate}} </button>
            </div>
        </div>
        </form>

    </div>
    </mat-expansion-panel>
</div>
</mat-accordion>
</div>
</div>
</div>
</div>
</div>
</div>